import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { formatCount } from "components/inputs/helpers/InputThroughputUtils";
const Connections = ({ openConnections, totalConnections }) => {
  const { t } = useTranslation("inputs");
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "overview.sections.active_connections",
      values: { open: formatCount(openConnections), total: formatCount(totalConnections) },
      components: { active: /* @__PURE__ */ React.createElement("span", { className: "active" }), total: /* @__PURE__ */ React.createElement("span", { className: "total" }) }
    }
  ), /* @__PURE__ */ React.createElement("br", null));
};
export default Connections;
